import { Validator } from '@vista-digital/validator';
/**
 * The size of a buttons height. General use cases:
 *
 * - Small: Form submission buttons, as they should match the input height.
 * - Medium: Common use cases e.g. proceed to a new page.
 * - Large: Attract the users attention e.g. sign up or purchase item.
 */
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "Small";
    ButtonSize["Medium"] = "Medium";
    ButtonSize["Large"] = "Large";
})(ButtonSize || (ButtonSize = {}));
export const defaultButtonSize = ButtonSize.Medium;
export const buttonSizeValidator = Validator.oneOf(Object.values(ButtonSize));
